import { Box, Center, Spinner } from '@chakra-ui/react';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { ResourceType, Transaction } from '../../_openapi/portfolio-optimizer';
import { useTransactions } from '../../api/transaction';
import { transactionsListColumns } from '../../Transactions/transactionsListColumns';
import { booleanCol } from '../../widgets/Table/columnHelpers/colDef';
import { Pagination } from '../../widgets/Table/Pagination';
import { Table } from '../../widgets/Table/Table';
import { TableControls } from '../../widgets/Table/TableControls';
import { useTableColumnSettings } from '../../widgets/Table/useTableColumnSettings';
import { useTableState } from '../../widgets/Table/useTableState';

export const PortfolioTransactionsTableTab = ({ pId }: { pId: string }) => {
    const { pagination, setPagination, sorting, setSorting, columnFilters, setColumnFilters } = useTableState({
        columns,
        initialSort: [{ id: 'tradeDate', desc: true }],
        initialFilters: [{ id: 'pId', value: pId }],
    });

    const { data: transactionsPage, isPending } = useTransactions({ pagination, columnFilters, sorting });

    const { columnVisibility, setColumnVisibility, columnOrder, setColumnOrder } =
        useTableColumnSettings('portfolioTransactions');

    const table = useReactTable({
        data: transactionsPage?.transactions || [],
        columns,
        state: {
            columnVisibility,
            columnOrder,
            pagination,
            sorting,
            columnFilters,
        },
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        onColumnOrderChange: setColumnOrder,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,
        manualSorting: true,
        manualFiltering: true,
        sortDescFirst: false,
    });

    if (isPending) {
        return (
            <Center width="100%" height="40vh">
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="teal.500" size="lg" />
            </Center>
        );
    }

    return (
        <Box>
            <TableControls table={table} resourceType={ResourceType.TRANSACTION} />
            <Table table={table} allowXOverflow />
            <Pagination table={table} totalItems={transactionsPage?.totalNr} />
        </Box>
    );
};

const columnHelper = createColumnHelper<Transaction>();
const EXCLUDE_COLUMNS = ['pId', 'aC', 'portfolioName', 'householdName', 'portfolioGuid'];
const columns = [
    ...transactionsListColumns.filter((col) => col.id && !EXCLUDE_COLUMNS.includes(col.id)),
    columnHelper.accessor('isCashTransaction', booleanCol({ id: 'isCashTransaction' })),
];
